import { render, staticRenderFns } from "./item_caret.vue?vue&type=template&id=0a988179&"
import script from "./item_caret.vue?vue&type=script&lang=js&"
export * from "./item_caret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "item_caret.vue"
export default component.exports